<script type="text/javascript">
	import { get,writable } from "svelte/store";
	import AppStore from "../AppStore";
	import LoadState from "../Enums/LoadState";
	import GeoHelper from "../Helpers/GeoHelper";
	import MapStore from "../Map/Store";
	import "../UI/LayerList/LayerList.scss";
	import LayerListSwitch from "../UI/LayerList/LayerListSwitch.svelte";
	import ModalWindow from "../UI/ModalWindow.svelte";
	
	let visible = AppStore.hazards.earthquakes.visible;
	let loadState = AppStore.hazards.earthquakes.meta.loadState;
	let loaded = false;
	let filter55 = writable(false);
	$: {
		loaded = $loadState === LoadState.LOADED;

		if (loaded) {
			let fc = AppStore.hazards.earthquakes.getDisplayLayer("earthquakes").featureCollection;
			let newFeatures = get(fc).features;
			if (!$filter55) {
				newFeatures = [];
				let existingFeatures = get(fc).features;
				for(let i = 0; i < existingFeatures.length; i++) {
					const title = existingFeatures[i].properties.Title;
					let magnitude = parseFloat(title.substr(2, 3));
					if (magnitude >= 5.5) {
						newFeatures.push(existingFeatures[i]);
					}
				}
			}
			const map = MapStore.helpers.getMap();
			map.getSource("earthquakes_0").setData(GeoHelper.emptyGeoJson(newFeatures));
		}
	}
	let hstyle = "font-weight:bold;margin-top:5px;margin-bottom:5px;";

</script>


{#if loaded}
	<ModalWindow
		title={`Earthquakes`}
		hasCloseButton={true}
		hasBackground={false}
		resizable={true}
		draggable={true}
		fullscreen={false}
		padding={true}
		position="top-right"
		height="70%"
		bind:open={$visible} >

		<p style={hstyle}>Filters</p>
		<div class='layer-list-component'>
			<LayerListSwitch label={"Show under 5.5 Magnitude"} bind:checked={$filter55} />
		</div>

	</ModalWindow>
{/if}
